module.exports = __webpack_public_path__ + "img/ripped.253d0c48.jpg";